import SimpleBar from 'simplebar'

// Gleicher Breakpoint wie im CSS (min-width: 992px), inkl. Scrollleiste
const isDesktopNav = () => window.matchMedia('(min-width: 992px)').matches

if (isDesktopNav()) {
	$('.nav--main .scroll').each(function (index, el) {
		var scrollbar = new SimpleBar(el, { autoHide: false })
		var content = el.querySelector('.simplebar-content')
		var wrapper = el.querySelector('.simplebar-wrapper')
		if (content) {
			content.style.padding = '0'
		}
		if (wrapper) {
			wrapper.style.margin = '0'
		}
	})
}

/*$('.nav--main > ul > li.has-submenu li').hover(function() {
    if($('> ul' ,this).length){
        var navHeight = $('> ul' ,this).height();
        var navElPosition = $(this).position().top;
        var minHeight = navHeight + navElPosition + 50;

        $(this).parent().css({'min-height' : minHeight})
    }

}, function() {
   $(this).parent().css({'min-height' : 0})
});
*/

/*$('.nav--main .lvl-1 > a').click(function(e) {
    e.preventDefault();
});*/

$('.nav--main .lvl-1 > a').click(function (e) {
	if (!isDesktopNav()) {
		return
	}

	var $link = $(this)
	var $item = $link.parent()
	var $submenu = $link.next('.scroll, .nav--main__submenu')

	if (!$submenu.length) {
		return
	}

	e.preventDefault()

	var isOpen = $item.hasClass('active')

	$('.nav--main .lvl-1').not($item).removeClass('active')
	$('.nav--main .lvl-1 > a').not($link).attr('aria-expanded', 'false')
	$('.nav--main .scroll, .nav--main__submenu').not($submenu).hide()

	$item.toggleClass('active', !isOpen)
	$item.toggleClass('just-closed', isOpen)
	$link.attr('aria-expanded', String(!isOpen))
	$submenu.toggle(!isOpen)
})

$(document).on('click', function (e) {
	if (!isDesktopNav()) {
		return
	}

	if ($(e.target).closest('.nav--main').length) {
		return
	}

	$('.nav--main .lvl-1').removeClass('active')
	$('.nav--main .lvl-1 > a').attr('aria-expanded', 'false')
	$('.nav--main .scroll, .nav--main__submenu').hide()
})

// Nach dem Schließen per Klick kein Hover-Grau, bis der Zeiger den Punkt verlässt
$('.nav--main .lvl-1').on('mouseleave', function () {
	$(this).removeClass('just-closed')
})

$('.nav-toggle').click(function (e) {
	$('body').toggleClass('nav-is-visible')
})

if ($(window).width() < 1024) {
	$('.nav-toggle-schneider').click(function (e) {
		$('body').toggleClass('nav-is-visible')
	})
}

$('.nav--main__container .icon--close').click(function (e) {
	$('body').removeClass('nav-is-visible')
	$('.nav--main .lvl-1').removeClass('active')
})

if ($('.nav--main .more').length) {
	var index = 0
	$('.nav--main .more').each(function () {
		$(this).attr('data-id', index)
		index++
	})
}

$('.nav--main .more p').click(function (e) {
	var $this = $(this)
	var parent = $(this).parent()
	if ($('.nav--main .more.active').length) {
		$('.nav--main .more.active').each(function () {
			if (parent.data('id') != $(this).data('id')) {
				$(this).find('> ul').slideToggle(200)
				$(this).toggleClass('active')
			}
		})
	}
	setTimeout(function (e) {
		$this.parent().find('> ul').slideToggle(200)
		$this.parent().toggleClass('active')
	}, 100)
})

$('.nav--main .simplebar-content > li')
	.not('.slider--nav')
	.mouseenter(function (e) {
		$('.nav--main .simplebar-content > li').not('.slider--nav').addClass('inactive')
		$(this).removeClass('inactive')
	})

/*$('.nav--main > ul > li').mouseenter(function(e) {
    $('.nav--main > ul > li > ul > li').not('.slider--nav').removeClass('inactive');
});*/

$('.nav--main .simplebar-content').mouseleave(function (e) {
	$('.nav--main .simplebar-content > li').not('.slider--nav').removeClass('inactive')
})

$('.language-active').click(function () {
	if ($('.sub-menu-language.active').length) {
		$('.sub-menu-language').removeClass('active')
		$('.nav-arrow').removeClass('active')
	} else {
		$('.sub-menu-language').addClass('active')
		$('.nav-arrow').addClass('active')
	}
})
